import logger from '@utils/logger';
import { useApplyItemsChangeMutation } from '@graphql/generated/graphql';

const useApplyItemsChange = () => {
  const { mutateAsync, isLoading, isError, data } = useApplyItemsChangeMutation({
    onError: (error) => {
      let loggedError: Error = Error('applyItemsChange failed');
      if (error instanceof Error) {
        loggedError = error;
      }
      void logger.error('Call to applyItemsChange resulted in error', loggedError);
    },
  });

  const errors = data?.applyItemsChange?.errors ?? [];

  return {
    mutateAsync,
    isLoading,
    isError,
    errors,
  };
};

export default useApplyItemsChange;
